import { useEffect, useState } from "react";
import { IoShieldHalf } from "react-icons/io5";
import { Card, Col, Form, Row, Button } from "react-bootstrap";
import { twoFactorAuthServices } from "../../APIServices/UserData/twoFactorAuthServices";
import { FaCheck, FaRegCopy } from "react-icons/fa";

const TwoFactorAuth = ({ openModule }) => {
  const [copiedField, setCopiedField] = useState(false);
  const [authType, setAuthType] = useState("");
  const [status, setStatus] = useState(false);
  const [appTwoFA, setAppTwoFA] = useState(false);
  const [emailTwoFA, setEmailTwoFA] = useState(false);
  const [loader, setLoader] = useState("");
  const [updateAuthType, setUpdateAuthType] = useState(false);
  const [otp, setOTP] = useState(["", "", "", "", "", ""]);
  const [otpSent, setOTPSent] = useState(false);
  const [base64, setBase64] = useState("");
  const [secret, setSecret] = useState("");
  const [check, setCheck] = useState(false);
  const [disable, setDisable] = useState(false);
  const [showQR, setShowQR] = useState(false);

  const OTP_LENGTH = 6;

  const getTwoFactorAuthType = async () => {
    setLoader(true);
    let data = await twoFactorAuthServices.getTwoFactorAuthType();
    setAuthType(data?.authType);
    setStatus(data?.status);
    setAppTwoFA(data?.appTwoFA);
    setEmailTwoFA(data?.emailTwoFA);
    setLoader(false);
  };

  const handleOtpBackspace = (e, index) => {
    if (e.key !== "Backspace") return;

    const newOtp = [...otp];
    newOtp[index] = "";
    setOTP(newOtp);

    if (index > 0) {
      document.getElementById(`otp-${index - 1}`)?.focus();
    }
  };

  const handleOtpPaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, OTP_LENGTH);

    if (pasted.length === OTP_LENGTH) {
      setOTP(pasted.split(""));
      document.getElementById(`otp-${OTP_LENGTH - 1}`)?.focus();
    }
  };

  const twoFactorAuthType = async () => {
    const userData = { authType };
    const data = await twoFactorAuthServices.twoFactorAuthType(userData);
    if (data?.statusCode === 200) {
      getTwoFactorAuthType();
      setUpdateAuthType(true);
    }
  };

  const generateQRCode = async () => {
    let data = await twoFactorAuthServices.generateQRCode();
    setBase64(data.base64);
    setSecret(data.secret);
  };

  const showQRCode = async () => {
    let data = await twoFactorAuthServices.showQRCode();
    setBase64(data?.base64);
    setSecret(data.secret);
    if (data) {
      setShowQR(true);
    }
  };

  const checkQRCode = async () => {
    let userData = {};
    userData.secret = secret;
    userData.otp = otp?.join("");
    await twoFactorAuthServices.checkQRCode(userData);
  };

  const enableTwoFactorAuth = async () => {
    let userData = {};
    userData.secret = secret;
    userData.otp = otp?.join("");
    let data = await twoFactorAuthServices.enableTwoFactorAuth(userData);
    if (data?.statusCode === 200) {
      getTwoFactorAuthType();
      setOTP(["", "", "", "", "", ""]);
    }
  };

  const disableTwoFactorAuth = async () => {
    let userData = {};
    userData.secret = secret;
    userData.otp = otp?.join("");
    let data = await twoFactorAuthServices.disableTwoFactorAuth(userData);
    if (data?.statusCode === 200) {
      getTwoFactorAuthType();
      setDisable(false);
      setShowQR(false);
      setCheck(false);
      setBase64("");
      setSecret("");
      setOTP(["", "", "", "", "", ""]);
    }
  };

  const getQRDataForDisable = async () => {
    let data = await twoFactorAuthServices.getQRData();
    setSecret(data?.secret);
    setDisable(true);
  };

  const sendOTPForEmailTwoFa = async () => {
    let data = await twoFactorAuthServices.emailOTPFor2FA();
    if (data?.statusCode === 200) {
      setOTPSent(true);
    }
  };

  const enableTwoFactorAuthByEmail = async () => {
    let userData = {};
    userData.otp = otp?.join("");
    let data = await twoFactorAuthServices.enableTwoFactorAuthByEmail(userData);
    if (data?.statusCode === 200) {
      getTwoFactorAuthType();
      setOTP(["", "", "", "", "", ""]);
      setOTPSent(false);
    }
  };

  const disableTwoFactorAuthByEmail = async () => {
    let userData = {};
    userData.otp = otp?.join("");
    let data =
      await twoFactorAuthServices.disableTwoFactorAuthByEmail(userData);
    if (data?.statusCode === 200) {
      getTwoFactorAuthType();
      setOTPSent(false);
      setOTP(["", "", "", "", "", ""]);
    }
  };

  useEffect(() => {
    setUpdateAuthType(status || false);
  }, [status]);

  useEffect(() => {
    if (openModule === "twoFactorAuthentication") {
      getTwoFactorAuthType();
    }
  }, [openModule]);

  const handleCopy = (e, text) => {
    e.stopPropagation();
    if (!text) return;
    navigator.clipboard.writeText(text);
    setCopiedField(true);
    setTimeout(() => setCopiedField(false), 1500);
  };

  const renderCopyIcon = (value) =>
    copiedField ? (
      <FaCheck className="text-success" />
    ) : (
      <FaRegCopy
        className="text-muted"
        style={{ cursor: "pointer", fontSize: 13 }}
        title="Copy"
        onClick={(e) => handleCopy(e, value)}
      />
    );

  return (
    <div className="h-100 d-flex flex-column">
      <div className="bg-white border-bottom px-4 py-3">
        <h6 className="fw-semibold m-0">Two-Factor Authentication (2FA)</h6>
        <Form.Text style={{ fontSize: 13 }} className={status ? "text-success" : "text-danger"}>
          Two-factor authentication is turned {status ? "on" : "off"} for your account.
        </Form.Text>
      </div>

      <div className="flex-grow-1 overflow-auto p-4">
        <Row className="g-4 justify-content-center">
          <Col xxl={4} lg={6} md={8}>
            <Card className="border-0 shadow-sm mb-3">
              <Card.Body className="lh-1">
                <Form.Text style={{ fontSize: 12 }} className="text-muted">
                  For your Password Manager account, two-factor authentication
                  adds an additional degree of security. When enabled, a second
                  factor will be needed in addition to your account password and
                  Secret Key to access your account on a new device.
                </Form.Text>
                <Form.Group className="my-3">
                  {!updateAuthType ? (
                    <>
                      <Form.Group className="mb-2">
                        <Form.Label
                          className="fw-bold"
                          style={{ fontSize: 13 }}
                        >
                          Authentication Type
                        </Form.Label>
                        <Form.Select
                          className="interactive-input rounded-1"
                          style={{ fontSize: 12, padding: "6px 15px" }}
                          onChange={(e) => setAuthType(e.target.value)}
                          value={authType}
                          disabled={loader}
                        >
                          <option value="apps">By Apps</option>
                          <option value="email">By Email</option>
                        </Form.Select>
                      </Form.Group>
                      <div className="hstack justify-content-end gap-2">
                        <Button
                          variant="outline-primary"
                          className="rounded-1 py-1 px-3"
                          style={{ fontSize: 13 }}
                          onClick={(e) => twoFactorAuthType()}
                        >
                          Next
                        </Button>
                      </div>
                    </>
                  ) : (
                    <>
                      {authType === "apps" && (
                        <>
                          {!disable ? (
                            <>
                              {!appTwoFA ? (
                                <>
                                  {!check ? (
                                    <>
                                      <Form.Group className="mb-2 text-center">
                                        {base64 ? (
                                          <>
                                            <div
                                              className="border rounded-1 p-1 m-auto"
                                              style={{ width: 180 }}
                                            >
                                              <img
                                                src={base64}
                                                className="w-100"
                                                alt="QR"
                                              />
                                            </div>
                                            <div
                                              className="hstack gap-2 justify-content-center mt-2"
                                              style={{ fontSize: 14 }}
                                            >
                                              {secret}
                                              {renderCopyIcon(secret)}
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            <IoShieldHalf
                                              className="text-danger"
                                              style={{ fontSize: 120 }}
                                            />
                                            <p className="fw-bold">Disabled</p>
                                          </>
                                        )}
                                      </Form.Group>
                                      <div className="hstack justify-content-center gap-2">
                                        <Button
                                          variant="outline-primary"
                                          className="rounded-1 py-1 px-3"
                                          style={{ fontSize: 13 }}
                                          onClick={() => {
                                            setUpdateAuthType(false);
                                            setBase64("");
                                            setSecret("");
                                          }}
                                        >
                                          Back
                                        </Button>
                                        <Button
                                          variant="outline-secondary"
                                          className="rounded-1 py-1 px-3"
                                          style={{ fontSize: 13 }}
                                          onClick={() => generateQRCode()}
                                        >
                                          {base64
                                            ? "Re-Generate QR"
                                            : "Generate QR"}
                                        </Button>
                                        {base64 && (
                                          <Button
                                            variant="outline-primary"
                                            className="rounded-1 py-1 px-3"
                                            style={{ fontSize: 13 }}
                                            onClick={() => setCheck(true)}
                                          >
                                            Next
                                          </Button>
                                        )}
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <Form.Group className="mb-3 text-center">
                                        <Form.Label className="mb-2 fw-bold">
                                          Verification Code
                                        </Form.Label>
                                        <div className="d-flex justify-content-center gap-2">
                                          {otp?.map((digit, index) => (
                                            <Form.Control
                                              key={index}
                                              id={`otp-${index}`}
                                              type="text"
                                              maxLength={1}
                                              inputMode="numeric"
                                              value={digit}
                                              className="text-center interactive-input fw-bold"
                                              style={{ width: 40, height: 42 }}
                                              onChange={(e) => {
                                                const value =
                                                  e.target.value.replace(
                                                    /\D/,
                                                    "",
                                                  );
                                                if (!value) return;

                                                const newOtp = [...otp];
                                                newOtp[index] = value;
                                                setOTP(newOtp);

                                                if (index < 5) {
                                                  document
                                                    .getElementById(
                                                      `otp-${index + 1}`,
                                                    )
                                                    ?.focus();
                                                }
                                              }}
                                              onPaste={handleOtpPaste}
                                              onKeyDown={(e) =>
                                                handleOtpBackspace(e, index)
                                              }
                                            />
                                          ))}
                                        </div>
                                      </Form.Group>
                                      <div className="hstack justify-content-center gap-2">
                                        <Button
                                          variant="outline-primary"
                                          className="rounded-1 py-1 px-3"
                                          style={{ fontSize: 13 }}
                                          onClick={() => {setCheck(false); setOTP(["", "", "", "", "", ""]);}}
                                        >
                                          Back
                                        </Button>
                                        <Button
                                          variant="outline-primary"
                                          className="rounded-1 py-1 px-3"
                                          style={{ fontSize: 13 }}
                                          onClick={() => checkQRCode()}
                                        >
                                          Verify
                                        </Button>

                                        <Button
                                          variant="outline-success"
                                          className="rounded-1 py-1 px-3"
                                          style={{ fontSize: 13 }}
                                          onClick={() => enableTwoFactorAuth()}
                                        >
                                          Verify and Enable
                                        </Button>
                                      </div>
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  {!showQR ? (
                                    <>
                                      <Form.Group className="mb-2 text-center">
                                        <IoShieldHalf
                                          className="text-success"
                                          style={{ fontSize: 120 }}
                                        />
                                        <p className="fw-bold">
                                          Enabled (2FA by Apps)
                                        </p>
                                      </Form.Group>
                                      <div className="hstack justify-content-center gap-2">
                                        <Button
                                          variant="outline-secondary"
                                          className="rounded-1 py-1 px-3"
                                          style={{ fontSize: 13 }}
                                          onClick={() => showQRCode()}
                                        >
                                          Show QR
                                        </Button>
                                        <Button
                                          variant="outline-danger"
                                          className="rounded-1 py-1 px-3"
                                          style={{ fontSize: 13 }}
                                          onClick={() => getQRDataForDisable()}
                                        >
                                          Disable
                                        </Button>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <Form.Group className="mb-2 text-center">
                                        {base64 && (
                                          <>
                                            <div
                                              className="border rounded-1 p-1 m-auto"
                                              style={{ width: 180 }}
                                            >
                                              <img
                                                src={base64}
                                                className="w-100"
                                                alt="QR"
                                              />
                                            </div>
                                            <div
                                              className="hstack gap-2 justify-content-center mt-2"
                                              style={{ fontSize: 14 }}
                                            >
                                              {secret}
                                              {renderCopyIcon(secret)}
                                            </div>
                                          </>
                                        )}
                                      </Form.Group>
                                      <div className="hstack justify-content-center gap-2">
                                        <Button
                                          variant="outline-secondary"
                                          className="rounded-1 py-1 px-3"
                                          style={{ fontSize: 13 }}
                                          onClick={() => setShowQR(false)}
                                        >
                                          Hide QR
                                        </Button>
                                        <Button
                                          variant="outline-danger"
                                          className="rounded-1 py-1 px-3"
                                          style={{ fontSize: 13 }}
                                          onClick={() => getQRDataForDisable()}
                                        >
                                          Disable
                                        </Button>
                                      </div>
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <Form.Group className="mb-3 text-center">
                                <Form.Label className="mb-2 fw-bold">
                                  Verification Code
                                </Form.Label>
                                <div className="d-flex justify-content-center gap-2">
                                  {otp?.map((digit, index) => (
                                    <Form.Control
                                      key={index}
                                      id={`otp-${index}`}
                                      type="text"
                                      maxLength={1}
                                      inputMode="numeric"
                                      value={digit}
                                      className="text-center interactive-input fw-bold"
                                      style={{ width: 40, height: 42 }}
                                      onChange={(e) => {
                                        const value = e.target.value.replace(
                                          /\D/,
                                          "",
                                        );
                                        if (!value) return;

                                        const newOtp = [...otp];
                                        newOtp[index] = value;
                                        setOTP(newOtp);

                                        if (index < 5) {
                                          document
                                            .getElementById(`otp-${index + 1}`)
                                            ?.focus();
                                        }
                                      }}
                                      onPaste={handleOtpPaste}
                                      onKeyDown={(e) =>
                                        handleOtpBackspace(e, index)
                                      }
                                    />
                                  ))}
                                </div>
                              </Form.Group>
                              <div className="hstack justify-content-center gap-2">
                                <Button
                                  variant="outline-primary"
                                  className="rounded-1 py-1 px-3"
                                  style={{ fontSize: 13 }}
                                  onClick={() => {
                                    setDisable(false);
                                    setOTP(["", "", "", "", "", ""]);
                                  }}
                                >
                                  Back
                                </Button>

                                <Button
                                  variant="outline-danger"
                                  className="rounded-1 py-1 px-3"
                                  style={{ fontSize: 13 }}
                                  onClick={() => disableTwoFactorAuth()}
                                >
                                  Disable 2FA
                                </Button>
                              </div>
                            </>
                          )}
                        </>
                      )}
                      {authType === "email" && (
                        <>
                          {!emailTwoFA ? (
                            <>
                              {!otpSent ? (
                                <>
                                  <Form.Group className="mb-2 text-center">
                                    <IoShieldHalf
                                      className="text-danger"
                                      style={{ fontSize: 120 }}
                                    />
                                    <p className="fw-bold mb-1">Disabled</p>
                                    <p style={{ fontSize: 12 }}>
                                      To enable Email 2FA, send OTP to the
                                      registered email address. If you click on
                                      Send OTP button, OTP will be automatically
                                      sent to your registered email address.
                                    </p>
                                  </Form.Group>
                                  <div className="hstack justify-content-center gap-2">
                                    <Button
                                      variant="outline-primary"
                                      className="rounded-1 py-1 px-3"
                                      style={{ fontSize: 13 }}
                                      onClick={() => {
                                        setUpdateAuthType(false);
                                      }}
                                    >
                                      Back
                                    </Button>
                                    <Button
                                      variant="outline-primary"
                                      className="rounded-1 py-1 px-3"
                                      style={{ fontSize: 13 }}
                                      onClick={() => sendOTPForEmailTwoFa()}
                                    >
                                      Send OTP
                                    </Button>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <Form.Group className="mb-3 text-center">
                                    <Form.Label className="mb-2 fw-bold">
                                      Verification Code
                                    </Form.Label>
                                    <div className="d-flex justify-content-center gap-2">
                                      {otp?.map((digit, index) => (
                                        <Form.Control
                                          key={index}
                                          id={`otp-${index}`}
                                          type="text"
                                          maxLength={1}
                                          inputMode="numeric"
                                          value={digit}
                                          className="text-center interactive-input fw-bold"
                                          style={{ width: 40, height: 42 }}
                                          onChange={(e) => {
                                            const value =
                                              e.target.value.replace(/\D/, "");
                                            if (!value) return;

                                            const newOtp = [...otp];
                                            newOtp[index] = value;
                                            setOTP(newOtp);

                                            if (index < 5) {
                                              document
                                                .getElementById(
                                                  `otp-${index + 1}`,
                                                )
                                                ?.focus();
                                            }
                                          }}
                                          onPaste={handleOtpPaste}
                                          onKeyDown={(e) =>
                                            handleOtpBackspace(e, index)
                                          }
                                        />
                                      ))}
                                    </div>
                                  </Form.Group>
                                  <div className="hstack justify-content-center gap-2">
                                    <Button
                                      variant="outline-primary"
                                      className="rounded-1 py-1 px-3"
                                      style={{ fontSize: 13 }}
                                      onClick={() => {setOTPSent(false); setOTP(["", "", "", "", "", ""]);}}
                                    >
                                      Back
                                    </Button>
                                    <Button
                                      variant="outline-primary"
                                      className="rounded-1 py-1 px-3"
                                      style={{ fontSize: 13 }}
                                      onClick={() =>
                                        enableTwoFactorAuthByEmail()
                                      }
                                    >
                                      Verify with Enable
                                    </Button>
                                  </div>
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              {!otpSent ? (
                                <>
                                  <Form.Group className="mb-2 text-center">
                                    <IoShieldHalf
                                      className="text-success"
                                      style={{ fontSize: 120 }}
                                    />
                                    <p className="fw-bold">
                                      Enabled (2FA by Email)
                                    </p>
                                  </Form.Group>
                                  <div className="hstack justify-content-center gap-2">
                                    <Button
                                      variant="outline-danger"
                                      className="rounded-1 py-1 px-3"
                                      style={{ fontSize: 13 }}
                                      onClick={() => sendOTPForEmailTwoFa()}
                                    >
                                      Disable
                                    </Button>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <Form.Group className="mb-3 text-center">
                                    <Form.Label className="mb-2 fw-bold">
                                      Verification Code
                                    </Form.Label>
                                    <div className="d-flex justify-content-center gap-2">
                                      {otp?.map((digit, index) => (
                                        <Form.Control
                                          key={index}
                                          id={`otp-${index}`}
                                          type="text"
                                          maxLength={1}
                                          inputMode="numeric"
                                          value={digit}
                                          className="text-center interactive-input fw-bold"
                                          style={{ width: 40, height: 42 }}
                                          onChange={(e) => {
                                            const value =
                                              e.target.value.replace(/\D/, "");
                                            if (!value) return;

                                            const newOtp = [...otp];
                                            newOtp[index] = value;
                                            setOTP(newOtp);

                                            if (index < 5) {
                                              document
                                                .getElementById(
                                                  `otp-${index + 1}`,
                                                )
                                                ?.focus();
                                            }
                                          }}
                                          onPaste={handleOtpPaste}
                                          onKeyDown={(e) =>
                                            handleOtpBackspace(e, index)
                                          }
                                        />
                                      ))}
                                    </div>
                                  </Form.Group>
                                  <div className="hstack justify-content-center gap-2">
                                    <Button
                                      variant="outline-primary"
                                      className="rounded-1 py-1 px-3"
                                      style={{ fontSize: 13 }}
                                      onClick={() => {setOTPSent(false); setOTP(["", "", "", "", "", ""]);}}
                                    >
                                      Back
                                    </Button>
                                    <Button
                                      variant="outline-danger"
                                      className="rounded-1 py-1 px-3"
                                      style={{ fontSize: 13 }}
                                      onClick={() =>
                                        disableTwoFactorAuthByEmail()
                                      }
                                    >
                                      Disable 2FA
                                    </Button>
                                  </div>
                                </>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </Form.Group>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default TwoFactorAuth;
